import React from 'react';
import { Breadcrumb } from 'components';
import SubscriptionPlans from './SubscriptionPlans';


const SubscriptionPlansSettings = () => {
  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <div>
        <Breadcrumb
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'Go Live Requirements', path: '/settings#go_live_requirements' },
            { name: 'Payment Options' }
          ]}
        />
      </div>
      <div className="mt-10 mx-10">
        <SubscriptionPlans />
      </div>
    </div>
  );
};

export default SubscriptionPlansSettings;
